<div class="component grid-example">
    <h2>Grids</h2>
    <div class="example">
        <sbw-grid>
            <sbw-grid-header>
                <div class="row">
                    <div class="column medium-6">
                        Grid header
                    </div>
                </div>
            </sbw-grid-header>
            <sbw-grid-body>
                <div class="column medium-6">
                    Grid body
                </div>
                <div class="row">
                    <div class="column medium-6">
                        Row #1
                    </div>
                </div>
                <div class="row">
                    <div class="column medium-6">
                        Row #2
                    </div>
                </div>
            </sbw-grid-body>
        </sbw-grid>
    </div>

    <div class="example">
        <sbw-grid [isCollapsable]=true>
            <sbw-grid-header>
                <div class="row">
                    <div class="column medium-6">
                        Grid header ([isCollapsable]=true)
                    </div>
                </div>
            </sbw-grid-header>
            <sbw-grid-body>
                <div class="column medium-6">
                    Grid body
                </div>
                <div class="row">
                    <div class="column medium-6">
                        Row #1
                    </div>
                </div>
                <div class="row">
                    <div class="column medium-6">
                        Row #2
                    </div>
                </div>
            </sbw-grid-body>
        </sbw-grid>
    </div>
</div>